import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';

import { makeStyles } from '@material-ui/core/styles';
import { preface } from './__data';

const useStyles = makeStyles((theme) => ({
  paper: {
    height: '100%',
    padding: theme.spacing(5),
    boxShadow: 'none'
  },
  section: {
    padding: '5rem 0',
    backgroundColor: 'white'
  },
}));

const Preface = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        className={classes.section}
        component="article"
        container
      >
        <Grid
          item
          md={7}
          sm={12}
          xs={12}
        >
          <Paper
            className={classes.paper}
          >
            <Typography variant="h1">
              NOTRE VISION
            </Typography>
            <Typography
              component="p"
              variant="body2"
            >
              Nous souhaitons offrir à tous la possibilité de jouer à SeedOut Fenua gratuitement.
            </Typography>
            <Typography
              component="p"
              variant="body2"
            >
              Développer un jeu vidéo est une belle aventure avec pleins de niveaux de difficultés différents.
            </Typography>
            <Typography
              component="p"
              variant="body2"
            >
              Notre Boss final, c’est vous ! Tout au long du développement nous avons en tête de vous offrir la plus belle expérience de jeu ...
            </Typography>
          </Paper>
        </Grid>
        <Grid
          item
          md={4}
          sm={12}
          xs={12}
        >
          <Paper className={classes.paper}>
            <CardMedia
              alt={preface.alt}
              className={classes.media}
              component="img"
              image={preface.img}
              object-fit
              title={preface.title}
            />
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

export default Preface;
